export const ASSOCIATE_TO_GPS_OPEN_MODAL = "ASSOCIATE_TO_GPS_OPEN_MODAL";
export const ASSOCIATE_TO_GPS_CLOSE_MODAL = "ASSOCIATE_TO_GPS_CLOSE_MODAL";

export const ASSOCIATE_TO_GPS_REQUEST = "ASSOCIATE_TO_GPS_REQUEST";
export const ASSOCIATE_TO_GPS_RESULT = "ASSOCIATE_TO_GPS_RESULT";